module.exports = __webpack_public_path__ + "static/logo18-2dc93359840534743979e282ff0054d7.png";